import React, { useEffect } from 'react';
import SignInButton from './SignIn.js';
import { useSignInContext } from './SignInContext.js';
import { FlexBox, Icon, Typography, Link } from '@vp/swan';

const LocalizedDefaultCopy = {
    "en-us": {
        link: "What is ID.me",
        verification: "Verification by ID.me"
    },
    "es-us": {
        link: "¿Qué es ID.me?",
        verification: "Verificación por ID.me"
    }
};
const DefaultButtonHelpCopy = (locale) => {
    return (React.createElement(FlexBox, { justifyContent: "left" },
        React.createElement(Icon, { mx: 1, src: "https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/icon-lock.svg" }),
        React.createElement(Typography, { mx: 1, fontSize: "xsmall" },
            LocalizedDefaultCopy[locale.toLowerCase()].verification,
            " \u2022 "),
        React.createElement(Link, { target: "_new", href: "https://www.id.me/about" },
            React.createElement(Typography, { fontSize: "xsmall" }, LocalizedDefaultCopy[locale.toLowerCase()].link))));
};
const IdMeVerificationButton = () => {
    const { isVerified, onSuccessfulVerification, localizedHelpCopy, locale, customerId } = useSignInContext();
    useEffect(() => {
        if (isVerified) {
            onSuccessfulVerification();
        }
    }, [isVerified]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SignInButton, null),
        localizedHelpCopy || DefaultButtonHelpCopy(locale)));
};

export { IdMeVerificationButton };
//# sourceMappingURL=Verification.js.map
